import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Urls } from 'kts-platform-frame/entry/constant';
import { Field } from 'kts-scaffold-framework/utils/doc';
import GroupButton from 'kts-platform-frame/display/components/GroupButton';
import { withRouter } from 'kts-platform-frame/routes';
import { Spin, Table, Modal } from 'antd';
import BillModelData from '../ModelData';

const { documentType, role, status} = BillModelData;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const { loadingUrls } = this.props;
        const columns = [{
                title: '单据类型',
                dataIndex: 'actualDocumentType',
                width: 120,
                render: (text, record) => {
                    return (<span> {documentType[record.documentType]}</span>);
                },
            }, {
                title: '交易角色',
                dataIndex: 'role',
                width: 110,
                render: (text, record) => {
                    return (<span> {role[record.role]}</span>);
                },
            }, {
                title: '编号',
                dataIndex: 'documentID',
                width: 180,
            }, {
                title: '交易方',
                dataIndex: 'counterparty',
                width: 200,
            }, {
                title: '单据状态',
                dataIndex: 'status',
                width: 120,
                render: (text, record) => {
                    return (<span> {status[record.status]}</span>);
                },
            }, {
                title: '填报时间',
                dataIndex: 'issueDate',
                width: 140,
                render: (text, record) => {
                    return (<span> {record.issueDate && Field.formatTime(record.issueDate)}</span>);
                },
            }, {
                title: '更新时间',
                dataIndex: 'lastModifyTime',
                width: 140,
                render: (text, record) => {
                    return (<span> {record.lastModifyTime && Field.formatTime(record.lastModifyTime)}</span>);
                },
            }, {
                title: '操作',
                dataIndex: 'allowedTargetStatus',
                width: 170,
                render: (text, record) => {
                    let buttons: any = [];
                    if (record.status === 'DRAFT') { // 草稿状态且不为发票
                        // 注!!!!!!! : 渝江压铸 只能查看 发送
                        if (this.isYuJiang(record.sender)) {
                            buttons.push({ title: '查看', onClick: () => { this.billDetail(record); } });
                            buttons.push({ title: '发送', onClick: () => { this.sendWarning(record.documentUUID); } });
                        } else {
                            if(record.documentType !== 'Invoice'){  // 文档类型不为发票
                                buttons.push({ title: '编辑', onClick: () => { this.editBill(record.documentType, record.documentUUID); } });
                            }else{
                                buttons.push({ title: '查看', onClick: () => { this.billDetail(record); } });
                            }
                            buttons.push({ title: '发送', onClick: () => { this.sendWarning(record.documentUUID); } });
                            buttons.push({ title: '删除', onClick: () => { this.deletWarning(record.documentUUID); } });
                        }
                    } else if(record.status === 'ISSUED'){ // 已开具状态
                        buttons.push({ title: '查看', onClick: () => { this.billDetail(record); } });
                        buttons.push({ title: '发送', onClick: () => { this.sendWarning(record.documentUUID); } });
                    }else {
                        buttons.push({ title: '查看', onClick: () => { this.billDetail(record); } });
                    }
                    record.allowedTargetStatus.forEach(element => {
                        switch (element) {
                            case 'REJECTED':
                                buttons.push({ title: '拒绝', onClick: () => ModulesAction.refuseM(record.documentUUID,'REJECTED', record.documentType) });
                                break;
                            case 'ACCEPTED':
                                buttons.push({ title: '接受', onClick: () => this.acceptedWarning(record.documentUUID, 'ACCEPTED', record.documentType) });
                                break;
                            case 'CANCEL_REQUESTING':
                                buttons.push({ title: '申请作废', onClick: () => this.acceptedWarning(record.documentUUID, 'CANCEL_REQUESTING') });
                                break;
                            case 'CANCEL_REJECTED':
                                buttons.push({ title: '拒绝作废', onClick: () => ModulesAction.refuseM(record.documentUUID, 'CANCEL_REJECTED') });
                                break;
                            case 'CANCELED':
                                buttons.push({ title: record.isSenderParty ? '作废' : '接受作废', onClick: () => this.acceptedWarning(record.documentUUID, 'CANCELED') });
                                break;
                            default:
                                break;
                        }
                    });
                    // 如果是存档的单据 只能查看 
                    if (record.isArchived) {
                        buttons = [];
                        buttons.push({ title: '查看', onClick: () => { this.billDetail(record); } });
                    }
                    return <GroupButton buttons={buttons}/>;
                },
            }];

        return (
            <div className={css.table}>
                <Spin spinning={loadingUrls.size > 0}>
                    <Table 
                        locale={{ emptyText : ''}}
                        rowKey="documentUUID"
                        dataSource={this.modulesState.dataList} 
                        columns={columns} 
                        size="small" 
                        className="kts-app-ant-table ui-list"
                        pagination={false}
                    />
                </Spin>
            </div>
        );
    }
    /**
     * 判断是否包含有渝江公司
     */
    private isYuJiang = (name: string) => {
        const yuArr = [
            "重庆渝江压铸有限公司", 
            "渝江集团", "重庆和顺鸿源汽车部件有限公司", "重庆渝江压铸有限公司", 
            "重庆市仁和压铸有限公司", "重庆渝江岚峰动力部件有限公司","重庆渝江新高模具有限公司",
            "天津渝江压铸有限公司","重庆渝岚模具有限公司","重庆渝江和顺压铸有限公司"
        ];
        let isInclude = false;
        yuArr.forEach((item) => {
            if (item === name) {
                isInclude = true;
            }
        });
        return isInclude;
    }
    /**
     * 是否删除?
     */
    private deletWarning = (documentUUID: string) => {
        Modal.confirm({
            title: '提示',
            content: '删除后无法恢复，确认删除?',
            onOk: () => {
                ModulesAction.documentDelete(documentUUID);
            },
        });
    }
    /**
     * 更新状态提示
     */
    private acceptedWarning = (documentUUID: string, actionType: string, type ?: string) => {
        this.modulesState.clickDocumentType = type;
        Modal.confirm({
            title: '提示',
            content: '您是否要在不查看该单据详情的情况下执行此操作?',
            onOk: () => {
                ModulesAction.updataDocumentStatus(documentUUID, actionType);
            },
        });
    }
    /**
     * 是否发送?
     */
    private sendWarning = (documentUUID: string) => {
        Modal.confirm({
            title: '提示',
            content: '您是否要在不查看该单据详情的情况下执行此操作?',
            onOk: () => {
                ModulesAction.checkDocument({documentUUID: documentUUID}).then( res => {
                    if(!res.er){
                        const fieldErrors: any = res.res;
                        if (res.res && fieldErrors && fieldErrors.length > 0) {
                            this.showErrorInfos(fieldErrors);
                        }else{
                            ModulesAction.documentSend(documentUUID);
                        }
                    }
                });
            },
        });
    }
    /** 错误信息提示 */
    private showErrorInfos = (fieldErrors: any[]) => {
        Modal.error({
            title: '发送失败',
            content: '当前单据包含不符合单据规范的内容，请点击“编辑”进入本单据检查',
          });
    }
    /**
     * 修改编辑
     */
    private editBill = (type: string,uuid: string) => {
        this.props.history.push(`/workbench/platform/document/editDocument/${type}/${uuid}`);
    }
    /**
     * 查看
     */
    private billDetail = (record: any) => {
        if(record.documentType === 'Invoice'){ // 发票  
            this.props.history.push(`/workbench/platform/document/invoiceDetail/${record.documentUUID}`);
        }else{
            this.props.history.push(`/workbench/platform/document/documentDetail/${record.documentUUID}`);
        }
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentList/UI.BillTable.tsx